// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_2z-OlwW","container":"_1tBL23N","avatarContainer":"_3RS-dnF","avatar":"_1bzprRy","remaining":"_3cRFQUL","tooltip":"_1txsZ39"};